import { useState } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Styles from "../styles/depoimentos.module.css";

import Depo1 from "../img/01.jpg";
import Depo2 from "../img/02.jpg";
import Depo3 from "../img/03.jpg";
import Depo4 from "../img/04.jpg";
import Depo5 from "../img/05.jpg";

const Depoimentos = () => {
  const depoimentos = [
    { id: 1, imagem: Depo1, alt: "Depoimento 1" },
    { id: 2, imagem: Depo2, alt: "Depoimento 2" },
    { id: 3, imagem: Depo3, alt: "Depoimento 3" },
    { id: 4, imagem: Depo4, alt: "Depoimento 4" },
    { id: 5, imagem: Depo5, alt: "Depoimento 5" },
  ];

  const [zoomAtivo, setZoomAtivo] = useState<string | null>(null);

  return (
    <section className={Styles.depoimentos}>
      <h2>O que nossos clientes dizem</h2>

      <Swiper
        spaceBetween={-200}
        slidesPerView={4}
        pagination={{
          clickable: true,
          bulletClass: "swiper-pagination-bullet",
          bulletActiveClass: "swiper-pagination-bullet-active",
        }}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        modules={[Pagination, Autoplay]}
        breakpoints={{
          320: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {depoimentos.map((depo) => (
          <SwiperSlide key={depo.id}>
            <div
              className={Styles.depoimentoCard}
              onClick={() => setZoomAtivo(depo.imagem)}
            >
              <img
                src={depo.imagem}
                alt={depo.alt}
                className={Styles.depoimentoImagem}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {zoomAtivo && (
        <div className={Styles.modalOverlay} onClick={() => setZoomAtivo(null)}>
          <div className={Styles.modalConteudo}>
            <img
              src={zoomAtivo}
              alt="Depoimento ampliado"
              className={Styles.modalImagem}
            />
            <button
              className={Styles.fecharModal}
              onClick={() => setZoomAtivo(null)}
            >
              <strong>✕</strong>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Depoimentos;
